import { MsalAuthenticator } from './msalAuthenticator';
import * as msal from "@azure/msal-browser";

export class UserAuthenticator extends MsalAuthenticator {
    public async authenticateUserAsync(): Promise<msal.AccountInfo | null> {
        const user = await this.signInAsync();
        return user;
    }
}